import ecgMonitor from './initial/flow';

const ecgMonitorFlows = { ecgMonitor };
export default ecgMonitorFlows;
